export default "__VITE_ASSET__CW5wF1R$__";